import { ActionTree } from "vuex";
import { TrnState } from "../types";

const actions: ActionTree<TrnState, any> = {
  setTrn({ commit }, trn) {
    commit("setTrn", trn);
  },
};

export default actions;
